import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "preview", "themeInput", "themeButton", "previewDescription" ]
  static values = {
    selectedThemeId: String,
    themesData: Array // Expecting an array of theme objects
  }

  connect() {
    this.updatePreview()
    this.updateButtonStyles()
    // Ensure the hidden input is set on connect, especially for new records or if value is pre-filled
    if (this.hasThemeInputTarget) {
      this.themeInputTarget.value = this.selectedThemeIdValue
    }
  }

  selectTheme(event) {
    const newThemeId = event.currentTarget.dataset.themeId
    if (newThemeId) {
      this.selectedThemeIdValue = newThemeId
      if (this.hasThemeInputTarget) {
        this.themeInputTarget.value = this.selectedThemeIdValue
      }
      // Value changed callbacks will trigger updates if defined
    }
  }

  selectedThemeIdValueChanged() {
    this.updatePreview()
    this.updateButtonStyles()
  }

  updatePreview() {
    if (!this.hasPreviewTarget || !this.selectedThemeIdValue) return

    const theme = this.themesDataValue.find(t => t.id === this.selectedThemeIdValue)
    if (theme) {
      // Remove all potential 'from-', 'via-', 'to-' classes from all themes
      this.themesDataValue.forEach(anyTheme => {
        if (anyTheme.from) this.previewTarget.classList.remove(anyTheme.from);
        if (anyTheme.via) this.previewTarget.classList.remove(anyTheme.via);
        if (anyTheme.to) this.previewTarget.classList.remove(anyTheme.to);
      });

      // Add new gradient classes
      if (theme.from) this.previewTarget.classList.add(theme.from);
      if (theme.via) this.previewTarget.classList.add(theme.via);
      if (theme.to) this.previewTarget.classList.add(theme.to);

      if (this.hasPreviewDescriptionTarget) {
        this.previewDescriptionTarget.textContent = theme.name;
      }
    }
  }

  updateButtonStyles() {
    this.themeButtonTargets.forEach(button => {
      if (button.dataset.themeId === this.selectedThemeIdValue) {
        button.classList.remove("border-zinc-800/50", "hover:border-zinc-700")
        button.classList.add("border-zinc-400", "bg-zinc-800/50")
        // Add check icon if it doesn't exist
        if (!button.querySelector(".theme-check-icon")) {
          const checkIcon = document.createElement('div');
          checkIcon.classList.add("theme-check-icon", "absolute", "top-1.5", "right-1.5");
          checkIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="text-zinc-400"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
          button.appendChild(checkIcon);
        }
      } else {
        button.classList.add("border-zinc-800/50", "hover:border-zinc-700")
        button.classList.remove("border-zinc-400", "bg-zinc-800/50")
        // Remove check icon if it exists
        const checkIcon = button.querySelector(".theme-check-icon");
        if (checkIcon) {
          checkIcon.remove();
        }
      }
    })
  }
} 